import clsx from 'clsx';
import { statusSemantic } from '../lib/colors';

/**
 * StatusPill — read-only twin of the main app's status pill (TRACKER_DESIGN.md §5).
 * No dropdown, no commit dialog — just the visual.
 */
export function StatusPill({ status, size = 'sm' }: { status: string; size?: 'xs' | 'sm' }) {
  const sem = statusSemantic(status);
  const palette: Record<typeof sem, { bg: string; border: string; text: string; dot: string }> = {
    success: { bg: 'bg-[var(--color-success-soft)]', border: 'border-[var(--color-success)]', text: 'text-[var(--color-success)]', dot: 'bg-[var(--color-success)]' },
    warning: { bg: 'bg-[var(--color-warning-soft)]', border: 'border-[var(--color-warning)]', text: 'text-[var(--color-warning)]', dot: 'bg-[var(--color-warning)]' },
    danger:  { bg: 'bg-[var(--color-danger-soft)]',  border: 'border-[var(--color-danger)]',  text: 'text-[var(--color-danger)]',  dot: 'bg-[var(--color-danger)]'  },
    neutral: { bg: 'bg-[var(--color-surface-2)]',    border: 'border-[var(--color-border)]',  text: 'text-[var(--color-ink-2)]',   dot: 'bg-[var(--color-ink-3)]'   },
  };
  const c = palette[sem];
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded border font-medium',
        size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs',
        c.bg,
        c.border,
        c.text,
      )}
    >
      <span className={clsx('inline-block rounded-full', size === 'xs' ? 'w-1.5 h-1.5' : 'w-2 h-2', c.dot)} />
      {status}
    </span>
  );
}
